import style from '../PickupPage.css';
import AppBar from '../../../components/shared/AppBar/AppBar';
import ListingSkeleton from '../../../components/shared/ListingSkeleton/ListingSkeleton';
import { useEffect, useRef, useState } from 'preact/hooks';
import PickupListingView from './PickupListingView';
import PickupService from '../../../services/pickup.service';
import useAndroidBackPress from '../../../hooks/back.listener.hook';
import NavigationUtils from '../../../utils/navigation.utils';

export default function PickupListingPage({ organization, type }) {
  const [loading, setLoading] = useState(true);
  const [locations, setLocations] = useState([]);
  const backRef = useRef(null);

  const handleBackClick = () => {
    NavigationUtils.back();
  };

  useAndroidBackPress(backRef.current, () => {
    backRef.current.props.onClick();
  });

  useEffect(() => {
    PickupService.listStores({ organization })
      .then(body => {
        const points = (body && body.pickupPoints) || [];
        setLocations(points);
        setLoading(false);
      })
      .catch(err => {
        NavigationUtils.navigate(NavigationUtils.Routes.TRY_AGAIN, false, {
          step: PickupListingPage.EventName,
          flow: 'pickup',
        });
      });
  }, []);

  return (
    <>
      <AppBar
        onBackClick={handleBackClick}
        className="fixed-bar"
        backRef={backRef}
      />

      <div className={style.container}>
        {loading ? (
          <ListingSkeleton className={style.main} />
        ) : (
          <PickupListingView locations={locations} type={type} />
        )}
      </div>
    </>
  );
}
PickupListingPage.EventName = 'pick_up_entry_point';
